import React from 'react'

function SectionNoDataComponent({ data , subtitle,children}) {
    return (
        <div style={{ width: '100%',  display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            No {data}
            <br />
            {children}
        </div>
    )
}

export default SectionNoDataComponent
